var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-selector",on:{"click":_vm.click}},[_c('div',{staticClass:"color-area",style:({ 'background-color' : _vm.bgColor })}),_c('PullDown',{attrs:{"userConfigColor":_vm.userConfigColor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }